class AdventCalendarModal extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', this.onResize.bind(this))

    this.externalEls?.trigger?.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, 'click', this.handleOpen.bind(this))
    })

    this.els?.close?.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose.bind(this))
    })
  }

  onResize () {
    const isMobile = window.innerWidth <= 768
    const videoMobile = this.els['video-mobile']?.element
    const videoDesktop = this.els['video-desktop']?.element

    const isMobileVideoPlaying = videoMobile && !videoMobile.paused
    const isDesktopVideoPlaying = videoDesktop && !videoDesktop.paused

    if (isMobileVideoPlaying && !isMobile) {
      videoMobile.pause()
      videoMobile.currentTime = 0
    } else if (isDesktopVideoPlaying && isMobile) {
      videoDesktop.pause()
      videoDesktop.currentTime = 0
    }
  }

  handleClose () {
    const videos = this.querySelectorAll('video')
    videos.forEach(video => {
      video.pause()
      video.currentTime = 0
    })

    this.setAttribute('aria-hidden', true)
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  handleOpen (e) {
    const triggerEl = e.currentTarget
    const contentType = triggerEl.dataset.contentType

    this.dataset.contentType = contentType

    this.setAttribute('aria-hidden', false)
    document.body.classList.toggle('util-SiteOverflowed', true)
  }
}

if (!customElements.get('advent-calendar-modal')) {
  customElements.define('advent-calendar-modal', AdventCalendarModal)
}
